import { render } from "./DataTableSkeletonControl.vue?vue&type=template&id=88099db4&scoped=true"
import script from "./DataTableSkeletonControl.vue?vue&type=script&lang=js"
export * from "./DataTableSkeletonControl.vue?vue&type=script&lang=js"

import "./DataTableSkeletonControl.vue?vue&type=style&index=0&id=88099db4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88099db4"]])

export default __exports__